<template>
    <div class="page-loader" v-if="showLoader || !isLoaded">
        <div class="cube-green"></div>
        <div class="cube-yellow"></div>
        <div class="cube-red"></div>
    </div>
</template>

<script>
export default {
    name: "pageLoader",
    data () {
        return {
            isLoaded: true,
        }
    },
    props: {
        showLoader: Boolean,
        listenToPageLoadState: Boolean,
    },
    mounted() {
        if(this.listenToPageLoadState) {
            this.isLoaded = false
            document.onreadystatechange = () => {
                if (document.readyState == 'complete') {
                    this.isLoaded = true;
                }
            }
        }
    },

}
</script>

<style scoped>
/*$colors: #36BC00, #FFBF00, #F84900;*/

.page-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(47, 47, 47, 0.11);
    z-index: 999;

}
.cube-green {
    width: 24px;
    height: 24px;
    background-color: #36BC00;
    margin-right: 10px;
    animation: compression 2s infinite ;
}
.cube-yellow {
    width: 24px;
    height: 24px;
    background-color: #FFBF00;
    margin-right: 10px;
    animation: compression 2s infinite .5s;
}
.cube-red {
    width: 24px;
    height: 24px;
    background-color: #F84900;
    animation: compression 2s infinite .9s;
}

@keyframes compression {
    from {
        transform: scale(.25);
    }
    50% {
        transform: scale(1);
    }
    to {
        transform: scale(.25);
    }
}

</style>